module.exports = __webpack_public_path__ + "img/txn-success.7e4b14f9.svg";